import ApiService from "../../common/services/ApiService";

const api = new ApiService();

export const getInstitute = async (instituteId) => {
   try {
      if(!instituteId || instituteId <= 0) {
        // Invalid institute ID, dont fetch
        return null;
      }
      const institute = await api.get(`institutes`, instituteId);
      return institute?.json?.data;
    } catch (error) {
      console.error(error);
    }
}